<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey, cardMetaKey } from "@/components/StickyNote/injectKeys";
import { action } from "@/components/action/action";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { useLinkStore } from "@/store/link";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const cardMeta = injectStrict(cardMetaKey);

const isVisible = computed(() => !cardMeta?.isPinningDisabled);
const isPinned = computed(() => useLinkStore().isPinned(card.id));
</script>

<template>
  <IconButton
    v-if="isVisible"
    v-bind="action(cardActions.togglePin)"
    :activated="isPinned"
    :text="isPinned ? $t('cardAction.unpin') : $t('cardAction.pin')"
  />
</template>
